import React from "react";

import { Avatar, CardHeader, Chip, IconButton, Tooltip, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { i18n } from "../../translate/i18n";
import ChannelBadge from "../ChannelBadge";

const TicketInfo = ({ contact, ticket, onClick, expanded }) => {
	const labels = (ticket?.labels || ticket?.tags || contact?.tags || []).map(label => typeof label === "string" ? label : label?.name).filter(Boolean);
	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer", padding: "10px 12px", minWidth: 0 }}
			titleTypographyProps={{ noWrap: true, style: { fontSize: ".95rem", fontWeight: 700 } }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" style={{ width: 40, height: 40 }} />}
			action={
				<Tooltip title={expanded ? "Cerrar información del cliente" : "Ver información del cliente"}>
					<IconButton
						size="small"
						aria-label={expanded ? "Cerrar información del cliente" : "Abrir información del cliente"}
						onClick={event => { event.stopPropagation(); onClick(); }}
						style={{ marginTop: 7 }}
					>
						<ExpandMoreIcon style={{ transition: "transform 160ms ease", transform: expanded ? "rotate(180deg)" : "none" }} />
					</IconButton>
				</Tooltip>
			}
			title={contact.name || "Conversación"}
			subheader={
				<span style={{ display: "inline-flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
					<ChannelBadge ticket={ticket} />
					{ticket.user && <Typography component="span" variant="caption" color="textSecondary">
						{i18n.t("messagesList.header.assignedTo")} {ticket.user.name}
					</Typography>}
					{labels.map(label => <Chip key={label} label={label} size="small" style={{ height: 20, fontSize: "0.65rem" }} />)}
				</span>
			}
		/>
	);
};

export default TicketInfo;
